import React from 'react';
import styled from 'styled-components';

interface UserSettingsInvitesTabProps {
  userId?: string; // userId might be needed for fetching invites
}

const UserSettingsInvitesTab: React.FC<UserSettingsInvitesTabProps> = ({ userId }) => {
  // Fetch and display user's invites based on userId
  return (
    <Container>
      <PlaceholderText>Invites Content - Coming Soon</PlaceholderText>
      {/* TODO: Implement invites listing */}
      {/* Example: <InvitesList userId={userId} /> */}
    </Container>
  );
};

const Container = styled.div`
  padding: 1rem 0;
`;

const PlaceholderText = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

export default UserSettingsInvitesTab;
